// extracted by mini-css-extract-plugin
export default {"menu":"AdminViewMenu_menu__iv0e5"};